export const SUPABASE_BUCKET_NAME = 'picture';
